// Games with a kind of blunder the engine found. Blunders live in the scans,
// which the filter does not read: whoever applies the filter resolves it
// first into `ids` (the game store's `resolveFilter`).
// Unresolved, it matches no game; resolved, `ids` decides.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { GAME_BLUNDERS, LOST_PIECES, type LostPiece } from '@chess/api-model';

/** A stage's blunders by the piece they gave away: reached from the dashboard, offered only while one is chosen. */
const LOST: Record<LostPiece, string> = { pawn: 'a pawn', knight: 'a knight', bishop: 'a bishop', rook: 'a rook', queen: 'the queen', mate: 'mate' };

export const blunder: FilterCriterion<'blunder'> = {
  key: 'blunder',
  query: 'blunder',
  many: true,
  parse: oneOf(GAME_BLUNDERS),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 60,
    more: true,
    label: 'Blunders',
    options: [
      ['middlegame', 'Blunder', 'Middlegame'],
      ['middlegame-miss', 'Miss', 'Middlegame'],
      ['middlegame-won', 'Lost a won position', 'Middlegame'],
      ['ending-blunder', 'Blunder', 'Ending'],
      ['ending-miss', 'Miss', 'Ending'],
      ['ending-won', 'Let a won position slip', 'Ending'],
      ['ending', 'Lost a won ending', 'Ending'],
      ['ending-slipped', 'Slipped a win', 'Ending'],
      ['ending-missed', 'Missed a win', 'Ending'],
      ['ending-time', 'Lost on time', 'Ending'],
      ['ending-lost', 'Lost the ending', 'Ending'],
    ],
    linkedLabel: (value) => {
      for (const [stage, name] of [['middlegame', 'Middlegame'], ['ending', 'Ending']] as const) {
        const piece = LOST_PIECES.find((p) => value === `${stage}-${p}`);
        if (piece) return piece === 'mate' ? `${name}: allowed mate` : `${name}: lost ${LOST[piece]}`;
      }
      return undefined;
    },
  },
};
